import { setLanguage, getLanguage } from "./auth";
import { Message } from "view-design";
import i18n from "../language/index";
import constant from "../const/const";
export default {
  // 根据缓存 赋值展示语言
  setLanguageValue() {
    const LanguageList = constant.LanguageList;
    let obj = {};
    let currentLanguage = getLanguage();
    let filterArray = [];

    let defaultType = process.env.VUE_APP_LANGUAGE_KEY || "zh_CN";
    if (!currentLanguage) {
      // 默认配置项语言
      setLanguage(defaultType);
      obj = LanguageList.filter((i) => i.type === defaultType)[0];
    } else {
      try {
        filterArray = LanguageList.filter((i) => i.type === currentLanguage);
        obj = filterArray[0];
      } catch (e) {
        setLanguage(defaultType);
        obj = LanguageList.filter((i) => i.type === defaultType)[0];
      }
    }
    return obj;
  },

  //  语言下拉框切换
  handleLanguage(type) {
    const LanguageList = constant.LanguageList;
    let obj = {};
    obj = LanguageList.filter((i) => i.type === type)[0];
    setLanguage(obj.type);
    setTimeout(() => {
      window.location.reload();
    }, 200);
    return obj;
  },

  handleUrl() {
    let url = null;
    if (getLanguage() === null || getLanguage() === undefined) {
      setLanguage("zh_CN");
      url = "https://www.google.cn/intl/en-US/chrome/";
    } else if (getLanguage() === "zh_CN") {
      url = "https://www.google.cn/intl/zh-CN/chrome/";
    } else {
      url = "https://www.google.cn/intl/en-US/chrome/";
    }
    return url;
  },

  getImgUrl(file) {
    let url = null;
    if (window.createObjectURL !== undefined) {
      // basic
      url = window.createObjectURL(file);
    } else if (window.URL !== undefined) {
      // mozilla(firefox)
      url = window.URL.createObjectURL(file);
    } else if (window.webkitURL !== undefined) {
      // webkit or chrome
      url = window.webkitURL.createObjectURL(file);
    }
    return url;
  },
  //   上传XML 方法
  showXML(e) {
    let el = e.currentTarget;
    let file = el.files[0];
    // 限制上传大小
    let fileSize = file.size;

    if (fileSize > 1024 * 1024 * 3) {
      Message.error(i18n.t("check.maxFileTip"));
      document.getElementById("uploadExcel").reset();
      return;
    }
    // 检验格式
    let lastName = file.name.split(".").reverse()[0];
    let allowPicReg = ["xml"];
    if (!allowPicReg.includes(lastName)) {
      Message.error(i18n.t("check.xmlTip"));
      return false;
    } else {
      return file;
    }
  },
  pxToRem(px) {
    return px / 16;
  },
  remToPx(rem) {
    return rem * 16;
  },

  getRound(num, len) {
    return Math.round(num * Math.pow(10, len)) / Math.pow(10, len);
  },

  getEnterOne() {
    return "\n";
  },
  getTab(type) {
    let str = null;
    if (Number(type) === 32) {
      str = "\t\t";
    } else if (Number(type) === 16) {
      str = "\t";
    }
    return str;
  },

  changeWidthPx(val, type) {
    let res1 = 1920 * Number(val);
    let res = 0;
    if (Number(res1) > 0) {
      let smRes = res1 / Number(type);
      res = this.getRound(smRes, 0);
    }

    return res;
  },

  changeHeightPx(val, type) {
    let res1 = 1080 * Number(val);
    let res = 0;
    if (Number(res1) > 0) {
      let smRes = res1 / Number(type);
      res = this.getRound(smRes, 0);
    }

    return res;
  },
  checkBrowser() {
    const ua = navigator.userAgent;
    if (/Firefox\/\d+/.test(ua)) return "Firefox";
    if (/Edg(e|\/)/.test(ua)) return "Edge";
    if (/Chrome\/\d+/.test(ua)) return "Chrome";
    return "Unknown";
  },
};
